import * as types from './constants';

// Get Lookbook Limits
export const getLookbookLimitsRequest = data => (
  { type: types.GET_LOOKBOOK_LIMITS_REQUEST, payload: data }
);

export const getLookbookLimitsDone = data => (
  { type: types.GET_LOOKBOOK_LIMITS_DONE, payload: data }
);

export const getLookbookLimitsFailed = errors => (
  { type: types.GET_LOOKBOOK_LIMITS_FAILED, payload: errors }
);
